import { render, staticRenderFns } from "./SwitchGroup.vue?vue&type=template&id=51f88b14&scoped=true"
import script from "./SwitchGroup.vue?vue&type=script&lang=js"
export * from "./SwitchGroup.vue?vue&type=script&lang=js"
import style0 from "./SwitchGroup.vue?vue&type=style&index=0&id=51f88b14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f88b14",
  null
  
)

export default component.exports